import { Box, Theme, SxProps, Avatar } from '@mui/material';

type MakeItPersonalHeaderProps = Readonly<{
  profilePicture?: string;
}>;

export const MakeItPersonalHeader = ({ profilePicture }: MakeItPersonalHeaderProps) => {
  return (
    <Box sx={imageContainer}>
      <Box component="img" src="/images/make-it-personal.png" sx={makeItPersonalImage} />
      {profilePicture && (
        <Box sx={outerRingStyle}>
          <Box sx={innerRingStyle}>
            <Avatar sx={profileAvatarStyle} src={profilePicture} alt="Profile Picture" />
          </Box>
        </Box>
      )}
    </Box>
  );
};

const imageContainer: SxProps<Theme> = {
  position: 'relative',
  width: {
    xs: '95%',
    sm: '50%',
    md: '95%',
  },
  alignSelf: 'center',
} as const;

const makeItPersonalImage: SxProps<Theme> = {
  width: '100%',
  alignSelf: 'center',
} as const;

const outerRingStyle: SxProps<Theme> = {
  position: 'absolute',
  left: '-6%',
  top: '30%',
  transform: 'translateY(-50%) rotate(-20deg)',
  width: '22%',
  aspectRatio: '1',
  border: (theme) => `1px solid ${theme.backrs.colors['Colors/Base/Black']}`,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

const innerRingStyle: SxProps<Theme> = ({ backrs }) =>
  ({
    width: '88%',
    height: '88%',
    border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }) as const;

const profileAvatarStyle: SxProps<Theme> = {
  width: '85%',
  height: '85%',
  border: (theme) => `1px solid ${theme.backrs.colors['Colors/Base/Black']}`,
} as const;
